import { render, staticRenderFns } from "./SoftnetDetail.vue?vue&type=template&id=0219b219&scoped=true&"
import script from "./SoftnetDetail.vue?vue&type=script&lang=js&"
export * from "./SoftnetDetail.vue?vue&type=script&lang=js&"
import style0 from "./SoftnetDetail.vue?vue&type=style&index=0&id=0219b219&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219b219",
  null
  
)

export default component.exports